import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  TextField,
  Typography,
  Input,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Checkbox,
  TableBody,
  Tabs,
  Tab,
  SelectChangeEvent,
  FormControl,
  Select,
  MenuItem,
  Switch,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import "react-phone-input-2/lib/bootstrap.css";
import MainContainer from "../../layout/MainContainer";
import { useNavigate, useParams } from "react-router-dom";
import { ChangeEvent, useEffect, useState, useSyncExternalStore } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import { error } from "console";
import * as Yup from "yup";
import { UploadMedia } from "../../utils/uploadMedia";
import PhoneInput from "react-phone-input-2";

import React from "react";
import { generateEncryptedKeyBody } from "../../utils/crypto";

import { CommonBody } from "../../types/General";
import Loader from "../../helpers/constants/Loader";
import WarnModal from "../../components/WarnModal";

import {
  errorToast,
  getFromStorage,
  STORAGE_KEYS,
  successToast,
} from "../../helpers";
import { toast } from "sonner";
import { useFormik } from "formik";
import {
  useAddSubAdminMutation,
  useAddSubRoleMutation,
  useDeleteSubRoleMutation,
  useLazyAllSubRoleQuery,
  useLazySubAdminByIdQuery,
  useUpdateSubAdminMutation,
} from "../../services/subadmin";
import useTranslation from "../../hooks/Translation";
// import WarnModal from "../../components/WarnModal";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

type SubAdminBody = {
  full_name: string;
  email: string;
  phone_no: string;
  sub_role: string;
  profile_picture: {};
  country_code: string;
  role_permission: {
    module: number;
    can_add_edit: boolean;
    can_view: boolean;
    can_be_delete: boolean;
  }[];
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
// interface Role {
//   isBlocked: boolean | undefined;
//   role: any;
//   _id: string;
// }
const AddSubAdmin = () => {
  const { _id: id } = useParams();
  // const id = false
  const t = useTranslation();
  const navigate = useNavigate();
  const [role, setRole] = useState("");
  const [newRole, setNewRole] = useState("");
  const [rolesData, setRolesData] = useState<any[]>([]);
  const [error, setError] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const [value, setValue] = useState<number>(0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState<string>("");
  const [phone, setPhone] = useState("");
  console.log(phone, "phone");
  const [phoneDisplay, setPhoneDisplay] = useState("");
  const [phoneCode, setPhoneCode] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [profilePicture, setProfilePicture] = useState("");
  const [loading, setLoading] = useState<boolean>();
  const [imageId, setImageId] = useState<unknown>();
  const [allSubRole] = useLazyAllSubRoleQuery();
  const [addSubRole] = useAddSubRoleMutation();
  const [deleteSubRole] = useDeleteSubRoleMutation();
  const [addSubAdmin] = useAddSubAdminMutation();
  const [subAdminById] = useLazySubAdminByIdQuery();
  const [updateSubAdmin] = useUpdateSubAdminMutation();
  const getLang = getFromStorage(STORAGE_KEYS.language);

  // console.warn(params)

  const getSubAdminById = async () => {
    try {
      const response = await subAdminById(id).unwrap();
      if (response?.status === 200) {
        console.log(response.data);
        subAdminFormik.setFieldValue("name", response?.data?.full_name);
        subAdminFormik.setFieldValue("email", response?.data?.email);
        setImage(response?.data?.profile_picture?.media_url);
        // subAdminFormik.setFieldValue("profile_picture",response?.data?.profile_picture?.id)
        setSelectedRole(response?.data?.sub_role_id);
        setPhoneDisplay(
          response?.data?.country_code.replace(0, 1, "") +
            response?.data?.phone_no
        );
        setImageId(response?.data?.profile_picture?.id);
        setPermissions(
          response?.data?.role_permission.map(
            (
              permission: {
                module: string;
                id: number;
                can_add_edit: boolean;
                can_view: boolean;
                can_be_delete: boolean;
              },
              index: number
            ) => ({
              label: permission.module,
              module_id: index + 1,
              id: permission.id,
              isEdit: permission.can_add_edit,
              isView: permission.can_view,
              isDelete: permission.can_be_delete,
              // disabled: true,
            })
          )
        );

        // setRolesData(response?.data)
        // console.log()
        //  setRows(response.data.response_object)
        // setCategoryData(response?.data?.response_object);
      } else {
        // setCategoryData([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  const roleFormik = useFormik({
    initialValues: {
      role: "",
      // name:""
    },
    validationSchema: Yup.object({
      role: Yup.string()
        .required(t.error.required)
        .min(10, "Minimum 10 characters are required"),
    }),
    onSubmit: async (values) => {
      //  successToast("Sumitted")
      let body: any = {
        role_name: values.role,
      };
      try {
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await addSubRole(encryptedBody).unwrap();
        if (response.status === 200) {
          successToast(response?.message || "New Role Add Successfully");
          roleFormik.resetForm();
          getAllSubRole();
          // navigate("/manage-subadmin");
        } else {
          errorToast(response.message);
        }
      } catch (e: any) {
        console.error("API call failed", e);
        errorToast(e?.data?.message);
      }
    },
  });

  const subAdminFormik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      profile_picture: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required(t.error.required)
        .matches(
          /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          t.error.validEmail
        )
        .matches(
          /^[^\uD800-\uDBFF\uD800-\uDBFF]+$/, // Regex to disallow emojis
          t.error.noEmoji
        ),
      name: Yup.string()
        .required(t.error.required)
        .min(2, t.error.minValidation)
        .max(25, "Maximum 25 characters are allowed")
        .test(
          "is-not-email",
          "Email address is not allowed in First Name",
          function (value) {
            return !Yup.string()
              .matches(
                /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
              )
              .isValidSync(value);
          }
        ),
    }),
    onSubmit: async (values) => {
      if (selectedRole.length === 0) return errorToast(t.main.selectRole);
      let rolePermission = id
        ? permissions.map((permission) => ({
            id: permission.id,
            module: permission.module_id,
            can_add_edit: permission.isEdit,
            can_view: permission.isView,
            can_be_delete: permission.isDelete,
          }))
        : permissions.map((permission) => ({
            module: permission.id,
            can_add_edit: permission.isEdit,
            can_view: permission.isView,
            can_be_delete: permission.isDelete,
          }));
      if (!imageId) return errorToast(t.error.pleaseUploadImage);
      let body = {
        full_name: values.name,
        email: values.email,
        phone_no: phone,
        sub_role: selectedRole,
        profile_picture: imageId,
        country_code: "+" + phoneCode,
        role_permission: rolePermission,
      };
      // console.warn("phone code =>",phoneCode,"phone  =>",phone)
      // console.log(body)
      // if(id===undefined){

      // }
      id ? UpdateSubAdmin(body) : AddSubAdmin(body);
    },
  });

  const AddSubAdmin = async (body: SubAdminBody) => {
    try {
      // const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await addSubAdmin(body).unwrap();
      if (response.status === 200) {
        successToast(response?.message || "New Sub Admin is Added ");
        // subAdminFormik.resetForm()
        navigate("/manage-subadmin");
      } else {
        errorToast(response.message);
      }
    } catch (e: any) {
      console.error("API call failed", e);
      errorToast(e?.data?.message);
    }
  };
  const UpdateSubAdmin = async (body: SubAdminBody) => {
    try {
      // const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await updateSubAdmin({ id, body }).unwrap();
      if (response.status === 200) {
        successToast(response?.message || "New Sub Admin is Update ");
        // subAdminFormik.resetForm()
        navigate("/manage-subadmin");
      } else {
        errorToast(response.message);
      }
    } catch (e: any) {
      console.error("API call failed", e);
      errorToast(e?.data?.message);
    }
  };

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    try {
      if (!file) {
        roleFormik.setFieldValue("profile_picture", "");
        setProfilePicture("");
        setImageId(null);
        return;
      }
      setLoading(true);
      const res = await UploadMedia(file);
      if (res?.status === 200) {
        setLoading(false);
        setImageId(res?.data[0]?.id);
        const imageUrl = res?.data[0]?.media_url;
        subAdminFormik.setFieldValue("profile_picture", imageUrl);
        setImage(imageUrl);
      } else {
        errorToast(res?.message);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setLoading(false);
      errorToast("Error uploading image. Please try again.");
    }
  };

  const getDeleteSubRole = async () => {
    try {
      const response = await deleteSubRole(selectedId).unwrap();
      if (response?.status === 200) {
        //  console.log(response.data)
        successToast(response?.data?.message || "");
        getAllSubRole();
      } else {
        errorToast(response?.data?.message || "");
        // setCategoryData([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  const getAllSubRole = async () => {
    //  let body = {
    //    start: 1,
    //    length: 10,
    //    search: debouncedSearchTerm,
    //  };
    //    console.log(body.search)
    try {
      const response = await allSubRole().unwrap();
      if (response?.status === 200) {
        console.log(response.data);
        setRolesData(response?.data);
        // console.log()
        //  setRows(response.data.response_object)
        // setCategoryData(response?.data?.response_object);
      } else {
        // setCategoryData([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  // const getAddSubRole=async()=>{
  //   let body ={
  //     role:newRole
  //   }
  //    try {
  //           const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
  //           const response = await addSubRole(encryptedBody).unwrap();
  //           if (response.status === 200) {
  //             console.log(response)
  //             successToast(response?.message || "Add New Role Successfully");
  //             // navigate("/manage-notifications");
  //             // navigate('/manage-subadmin')
  //           } else {
  //             errorToast(response.message);
  //           }
  //         } catch (e: any) {
  //           console.error("API call failed", e);
  //           errorToast(e?.data?.message);
  //         }
  // }

  // console.log(phone,phoneDisplay,phoneCode);
  // const handleRoleChange = (event:HTMLInputElement | HTMLTextAreaElement) => {
  //   setRole(event.target.value as string);
  // };

  // const handleRoleSubmit=()=>{
  //   if (newRole.length <= 5)
  //     if (newRole.length > 5) {
  //       getAddSubRole()
  //         // handleRoleDataChange(event as any)
  //         // navigate('manage-subadmin')
  //         // toast.success(newRole)
  //     }
  //     toast.error("Role name cant exceed 5 characters");
  // }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    // setPage(1);
  };

  const handleChangePhone = (phone: any, country: any) => {
    console.warn(phone);
    console.warn(country);
    setPhone(phone.replace(country.dialCode, ""));
    setPhoneCode(country.dialCode);
    setPhoneDisplay(phone);
  };

  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [permissions, setPermissions] = useState([
    {
      id: 1,
      label: t.sideBar.dashboard,
      isEdit: false,
      isView: false,
      isDelete: false,
      module_id: 0,
      disabled: true,
    },
    {
      id: 2,
      label: t.sideBar.manageCustomers,
      isEdit: false,
      isView: false,
      isDelete: false,
      module_id: 0,
      disabled: true,
    },
    {
      id: 3,
      label: t.sideBar.manageVendors,
      isEdit: false,
      isView: false,
      module_id: 0,
      isDelete: false,
      disabled: true,
    },
    {
      id: 4,
      label: t.sideBar.manageCategories,
      isEdit: false,
      isView: false,
      module_id: 0,
      isDelete: false,
      disabled: true,
    },
    {
      id: 5,
      label: t.sideBar.manageProducts,
      isEdit: false,
      isView: false,
      module_id: 0,
      isDelete: false,
      disabled: true,
    },
    {
      id: 6,
      label: t.sideBar.manageQuotes,
      isEdit: false,
      isView: false,
      module_id: 0,
      isDelete: false,
      disabled: true,
    },

    {
      id: 7,
      label: t.sideBar.manageDiscount,
      isEdit: false,
      module_id: 0,
      isView: false,
      isDelete: false,
      disabled: true,
    },
    {
      id: 8,
      label: t.sideBar.manageOrders,
      isEdit: false,
      module_id: 0,
      isView: false,
      isDelete: false,
      disabled: true,
    },
    {
      id: 9,
      label: t.sideBar.manageReturnExchange,
      isEdit: false,
      module_id: 0,
      isView: false,
      isDelete: false,
      disabled: true,
    },
    {
      id: 10,
      label: t.sideBar.manageChats,
      isEdit: false,
      module_id: 0,
      isView: false,
      isDelete: false,
      disabled: true,
    },
    {
      id: 11,
      label: t.sideBar.managePayments,
      isEdit: false,
      module_id: 0,
      isView: false,
      isDelete: false,
      disabled: true,
    },
    {
      id: 12,
      label: t.sideBar.analytics,
      isEdit: false,
      module_id: 0,
      isView: false,
      isDelete: false,
      disabled: true,
    },
    {
      id: 13,
      label: t.sideBar.notificationManagement,
      isEdit: false,
      isView: false,
      module_id: 0,
      isDelete: false,
      disabled: true,
    },

    {
      id: 14,
      label: t.sideBar.settings,
      isEdit: false,
      isView: false,
      module_id: 0,
      isDelete: false,
      disabled: true,
    },
  ]);

  useEffect(() => {
    getAllSubRole();
  }, []);
  useEffect(() => {
    if (id) {
      setValue(1);
      getSubAdminById();
    }
  }, []);

  return (
    <>
      <Loader isLoad={isLoading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">
            {id ? t.main.editSubAdmin : t.main.addSubAdmin}
          </h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate("/manage-subadmin");
            }}
          >
            {t.main.back}
          </Button>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            <Box className="flx_sc">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label={t.main.addRole} {...a11yProps(0)} />
                <Tab
                  label={!id ? t.main.addSubAdmin : t.main.editSubAdmin}
                  {...a11yProps(1)}
                />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <form onSubmit={roleFormik.handleSubmit}>
                <CardContent sx={{ p: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <Typography className="custom_label">
                        {t.main.addRole}
                      </Typography>
                      <TextField
                        hiddenLabel
                        type="text"
                        name="role"
                        variant="outlined"
                        fullWidth
                        placeholder="Role"
                        value={roleFormik.values.role}
                        onChange={roleFormik.handleChange}
                        onBlur={roleFormik.handleBlur}
                        error={
                          roleFormik.touched.role &&
                          Boolean(roleFormik.errors.role)
                        }
                        helperText={
                          roleFormik.touched.role && roleFormik.errors.role
                            ? roleFormik.errors.role.toString()
                            : ""
                        }
                      />
                    </Grid>
                  </Grid>

                  <div className="form_btn">
                    <Button
                      size="large"
                      type="submit"
                      className="btn btn_primary"
                    >
                      {t.main.add}
                    </Button>
                  </div>
                </CardContent>
              </form>

              <Grid item xs={12}>
                <TableContainer className="table_container">
                  <Box className="heading"></Box>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell className="mn_hdng">S.No.</TableCell>
                        <TableCell className="mn_hdng">{t.main.role}</TableCell>
                        {/* <TableCell className="mn_hdng">Status</TableCell> */}
                        <TableCell className="mn_hdng">
                          {t.main.delete}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {rolesData?.length ? (
                      rolesData?.map((row, i) => (
                        <TableBody>
                          <TableRow>
                            <TableCell className="mn_hdng">{i + 1}</TableCell>
                            <TableCell>{row.role_name}</TableCell>
                            {/* <TableCell>
                                  <Switch
                                    checked={!row.isBlocked}
                                    // checked={row.enabled}
                                    onChange={()=>handleStatusChange(i)}
                                    // onChange={() => handleToggle(index)}
                                  />
                                </TableCell> */}
                            <TableCell>
                              <IconButton
                                onClick={() => {
                                  setSelectedId(row.id);
                                  setOpen(true);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ))
                    ) : (
                      <TableBody
                        sx={{
                          padding: "20px",
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        <TableRow

                        // sx={{ padding: "20px", textAlign: "center" }}
                        >
                          <TableCell
                            colSpan={5}
                            sx={{ padding: "20px", textAlign: "center" }}
                          >
                            {t.error.noData}
                          </TableCell>{" "}
                          {/* No Roles Added */}
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <form onSubmit={subAdminFormik.handleSubmit}>
                <CardContent sx={{ p: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className="custom_label">
                        {t.main.image}
                      </Typography>
                      {image ? (
                        <div className="upload_image_preview">
                          <CardMedia
                            component="img"
                            image={image}
                            alt="photo"
                          />
                          <CancelIcon
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                              setImage("");
                            }}
                          />
                        </div>
                      ) : (
                        <Box className="upload_image">
                          <label htmlFor="icon-button-file">
                            <Input
                              sx={{ display: "none" }}
                              id="icon-button-file"
                              type="file"
                              inputProps={{
                                accept: "image/png,image/jpeg",
                              }}
                              onChange={handleImageUpload}
                            />
                            <Button
                              component="span"
                              className="upload_image_btn"
                            >
                              <img
                                src={
                                  image
                                    ? image
                                    : "/static/images/user_placeholder.png"
                                }
                                alt=""
                              />
                              <CameraAltIcon />
                            </Button>
                          </label>
                        </Box>
                      )}
                      {error && !image ? (
                        <h6 className="err_msg">{t.error.required}</h6>
                      ) : (
                        ""
                      )}
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <Typography className="custom_label">
                        {t.main.fullName}
                      </Typography>
                      <TextField
                        hiddenLabel
                        type="text"
                        name="name"
                        variant="outlined"
                        fullWidth
                        placeholder={t.main.fullName}
                        value={subAdminFormik.values.name}
                        onChange={subAdminFormik.handleChange}
                        onBlur={subAdminFormik.handleBlur}
                        error={
                          subAdminFormik.touched.name &&
                          Boolean(subAdminFormik.errors.name)
                        }
                        helperText={
                          subAdminFormik.touched.name &&
                          subAdminFormik.errors.name
                            ? subAdminFormik.errors.name.toString()
                            : ""
                        }
                      ></TextField>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <Typography className="custom_label">
                        {t.main.email}
                      </Typography>
                      <TextField
                        hiddenLabel
                        type="text"
                        name="email"
                        variant="outlined"
                        fullWidth
                        placeholder={t.main.email}
                        value={subAdminFormik.values.email}
                        onChange={subAdminFormik.handleChange}
                        onBlur={subAdminFormik.handleBlur}
                        error={
                          subAdminFormik.touched.email &&
                          Boolean(subAdminFormik.errors.email)
                        }
                        helperText={
                          subAdminFormik.touched.email &&
                          subAdminFormik.errors.email
                            ? subAdminFormik.errors.email.toString()
                            : ""
                        }
                      ></TextField>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <Typography className="custom_label">
                        {t.main.phoneNumber}
                      </Typography>
                      <PhoneInput
                        country={"us"}
                        placeholder="0 (000) 000-000"
                        enableSearch={true}
                        inputStyle={{
                          width: "100%",
                          direction: getLang === "ar" ? "rtl" : "ltr",
                          paddingRight: getLang === "ar" ? "80px" : "0px",
                        }}
                        value={phoneDisplay}
                        buttonStyle={{
                          marginRight: getLang === "ar" ? "40px" : "0px",
                        }}
                        onChange={(phone, country) => {
                          // console.log()
                          //  subAdminFormik.setFieldValue("phone", value)}}
                          // onChange={(phone, country) =>
                          handleChangePhone(phone, country);
                        }}
                        isValid={!(error && !phone)}
                      />
                      {error && !phone && (
                        <Typography variant="caption" color="error">
                          {t.error.required}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <Typography className="custom_label">
                        {t.main.selectRole1}
                      </Typography>

                      <FormControl sx={{ width: "100%" }}>
                        <Select
                          className="select_div"
                          fullWidth
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={selectedRole}
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          displayEmpty
                          onChange={(e) => {
                            setSelectedRole(e.target.value);
                          }}
                        >
                          <MenuItem value="" disabled>
                            {t.main.select}
                          </MenuItem>
                          {rolesData.map((row: any, index: number) => {
                            return (
                              <MenuItem value={row.id}>
                                {row.role_name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <TableContainer className="table_container">
                      <Box className="heading"></Box>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell className="mn_hdng">
                              {t.main.module}
                            </TableCell>
                            <TableCell className="mn_hdng">
                              {t.main.addEdit}
                            </TableCell>
                            <TableCell className="mn_hdng">
                              {t.main.view}
                            </TableCell>
                            <TableCell className="mn_hdng">
                              {t.main.delete}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {permissions.map((row: any, i: number) => (
                            <TableRow>
                              <TableCell className="">{row.label}</TableCell>
                              <TableCell>
                                <Checkbox
                                  {...label}
                                  checked={row.isEdit}
                                  onChange={() => {
                                    if (
                                      row.isEdit == false &&
                                      row.isView == false
                                    ) {
                                      setPermissions((prevData) => {
                                        return prevData.map(
                                          (row: any, index: number) => {
                                            if (index == i) {
                                              return { ...row, isView: true };
                                            }
                                            return row;
                                          }
                                        );
                                      });
                                    }
                                    setPermissions((prevData: any) => {
                                      return prevData.map(
                                        (row: any, index: number) => {
                                          if (i == index) {
                                            return {
                                              ...row,
                                              isEdit: !row.isEdit,
                                            };
                                          }
                                          return row;
                                        }
                                      );
                                    });
                                  }}
                                />
                              </TableCell>
                              <TableCell>
                                <Checkbox
                                  {...label}
                                  onChange={() => {
                                    if (
                                      row.isView == true &&
                                      (row.isEdit == true ||
                                        row.isDelete == true)
                                    ) {
                                      setPermissions((prevData: any) => {
                                        return prevData.map(
                                          (row: any, index: number) => {
                                            if (index == i) {
                                              return {
                                                ...row,
                                                isDelete: false,
                                                isEdit: false,
                                              };
                                            } else return row;
                                          }
                                        );
                                      });
                                    }
                                    setPermissions((prevData: any) => {
                                      return prevData.map(
                                        (row: any, index: number) => {
                                          if (index == i) {
                                            return {
                                              ...row,
                                              isView: !row.isView,
                                            };
                                          }
                                          return row;
                                        }
                                      );
                                    });
                                  }}
                                  checked={row.isView}
                                />
                              </TableCell>
                              <TableCell>
                                <Checkbox
                                  {...label}
                                  onChange={() => {
                                    if (
                                      row.isDelete == false &&
                                      row.isView == false
                                    ) {
                                      setPermissions((prevData) => {
                                        return prevData.map(
                                          (row: any, index: number) => {
                                            if (index == i) {
                                              return { ...row, isView: true };
                                            }
                                            return row;
                                          }
                                        );
                                      });
                                    }
                                    setPermissions((prevData) => {
                                      return prevData.map(
                                        (row: any, index: number) => {
                                          if (index == i) {
                                            return {
                                              ...row,
                                              isDelete: !row.isDelete,
                                            };
                                          }
                                          return row;
                                        }
                                      );
                                    });
                                  }}
                                  checked={row.isDelete}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                  <div className="form_btn">
                    <Button
                      size="large"
                      type="submit"
                      className="btn btn_primary"
                      // onClick={(e) => {
                      //   e.preventDefault();
                      //   if (name == "") {
                      //     // showError("Full name is required")
                      //     return;
                      //   }
                      //   if (name.length > 50) {
                      //     //   showError("Full name cant exceed 50");
                      //     return;
                      //   }
                      //   if (email == "") {
                      //     //   showError("Email is required")
                      //     return;
                      //   }
                      //   // if(!isValidEmail(email))
                      //   //   {
                      //   //     // showError("Enter valid email");
                      //   //     return;
                      //   //   }
                      //   if (phone == "") {
                      //     // showError("Phone is required")
                      //     return;
                      //   }
                      //   if (phone.length < 6 || phone.length > 16) {
                      //     //   showError("Invalid phone")
                      //     return;
                      //   }
                      //   if (selectedRole == "") {
                      //     //   showError("Selection of role is required")
                      //     return;
                      //   }
                      // }}
                    >
                      {id ? "Update" : "Save"}
                    </Button>
                  </div>
                </CardContent>
              </form>
            </CustomTabPanel>
          </Box>
        </Card>
        <WarnModal
          setOpen={setOpen}
          open={open}
          name={t.main.role}
          handleDelete={getDeleteSubRole}
        />
      </div>
    </>
  );
};

export default AddSubAdmin;
